import styled from 'styled-components';
import { media } from '../../utils';

export const Wrapper = styled.article`
	max-width: 65rem;
	margin: auto;

	h1 {
		text-align: center;
	}
`;

export const Content = styled.div`
	position: relative;
	display: grid;
	gap: var(--gap);
	align-items: center;
	max-width: 45rem;
	margin: auto;

	${media.medium`
		grid-template-columns: repeat(2, 1fr);
		padding: calc(var(--gap) *2);
		background: var(--cardBg);
		box-shadow: var(--level-2);
		border-radius: 10px;
		color: var(--color);
	`}
`;

export const FeaturedImg = styled.div`
	overflow: hidden;
	height: fit-content;
	background: var(--photoBg);
	padding: 0.5rem;
	position: relative;

	.gatsby-image-wrapper {
		height: auto;

		${media.small`
			height: auto;
		`}
	}
`;

export const Description = styled.p`
	margin-top: 0;

	&:first-letter {
		font: normal 5rem var(--serif);
		float: left;
		margin: var(--lineHeight) var(--lineHeight) 0 0;
		line-height: 0.65;
		color: var(--photoBg);
	}

	a {
		margin-top: 1rem;
	}
`;
